(function () {
  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }
    callback();
  }

  function keyFrom(value) {
    var text = String(value || '').toLowerCase();
    if (text.indexOf('both') !== -1 || text.indexOf('bundle') !== -1) return 'both';
    if (text.indexOf('ginger') !== -1) return 'ginger';
    if (text.indexOf('cola') !== -1) return 'cola';
    return text.replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'default';
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP'
    }).format((Number(cents) || 0) / 100);
  }

  function canCountFor(variant) {
    if (variant && variant.canCount) return Number(variant.canCount) || 12;
    var key = keyFrom((variant && (variant.option1 || variant.title)) || '');
    return key === 'both' ? 24 : 12;
  }

  ready(function () {
    var root = document.querySelector('[data-srtd-root]');
    if (!root || root.dataset.srtdReady === 'true') return;
    root.dataset.srtdReady = 'true';

    var dataNode = root.querySelector('[data-srtd-product-json]');
    if (!dataNode) return;

    var data;
    try {
      data = JSON.parse(dataNode.textContent);
    } catch (error) {
      return;
    }

    var product = data.product || {};
    var variants = product.variants || [];
    if (!variants.length) return;

    var selected = variants.find(function (variant) {
      return String(variant.id) === String(product.selectedVariantId);
    }) || variants.find(function (variant) {
      return variant.available;
    }) || variants[0];

    function setVariant(variant) {
      if (!variant) return;
      selected = variant;
      var key = keyFrom(variant.option1 || variant.title);
      var canCount = canCountFor(variant);
      var caseSize = canCount + ' × 250ml cans';

      document.querySelectorAll('[data-rtd-variant-input]').forEach(function (input) {
        input.value = variant.id;
      });

      document.querySelectorAll('[data-rtd-price]').forEach(function (node) {
        node.textContent = variant.priceFormatted || formatMoney(variant.price);
      });

      document.querySelectorAll('[data-rtd-unit-price]').forEach(function (node) {
        node.textContent = formatMoney((Number(variant.price) || 0) / canCount) + ' per can';
      });

      document.querySelectorAll('[data-rtd-case-count]').forEach(function (node) {
        node.textContent = canCount;
      });

      document.querySelectorAll('[data-rtd-mini-case-count]').forEach(function (node) {
        node.textContent = canCount;
      });

      document.querySelectorAll('[data-rtd-case-heading]').forEach(function (node) {
        node.textContent = 'Case of ' + canCount;
      });

      document.querySelectorAll('[data-rtd-case-size]').forEach(function (node) {
        node.textContent = caseSize;
      });

      document.querySelectorAll('[data-rtd-selected-flavour]').forEach(function (node) {
        node.textContent = variant.option1 || variant.title;
      });

      document.querySelectorAll('[data-rtd-add-to-cart]').forEach(function (button) {
        button.disabled = !variant.available;
        button.textContent = variant.available ? (button.dataset.availableText || 'ADD TO CART') : (button.dataset.soldOutText || 'SOLD OUT');
      });

      document.querySelectorAll('[data-rtd-main-image]').forEach(function (image) {
        if (!variant.image) return;
        image.src = variant.image;
        image.alt = variant.imageAlt || variant.title || '';
        image.removeAttribute('srcset');
      });

      document.querySelectorAll('[data-rtd-flavour-button]').forEach(function (button) {
        var isActive = String(button.dataset.variantId) === String(variant.id);
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-checked', isActive ? 'true' : 'false');
      });

      document.querySelectorAll('[data-rtd-flavour-content]').forEach(function (node) {
        node.hidden = node.dataset.flavourKey !== key;
      });

      document.querySelectorAll('[data-rtd-gallery-item]').forEach(function (node) {
        var flavour = node.dataset.flavourKey || 'all';
        node.hidden = flavour !== 'all' && flavour !== key;
      });

      document.dispatchEvent(new CustomEvent('srtd:variant-change', {
        detail: { variant: variant, flavourKey: key }
      }));
    }

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-rtd-flavour-button]');
      if (!button) return;
      var variant = variants.find(function (item) {
        return String(item.id) === String(button.dataset.variantId);
      });
      setVariant(variant);
    });

    setVariant(selected);
  });
})();
